export default __webpack_public_path__ + "static/media/Wheels Industry.962370eb.png";